import { TransferJobTaskStatus } from '@frameio/graphql-client/client-schema/transfers/state/transferJobTaskStatus';
import type {
  UploadJobItemProgressPayload,
  UxpTransferState,
} from '@frameio/graphql-client/generated';
import { createOrUpdateTransferState } from '@frameio/transfers/utils';
import { useUploadJobEventsSubscription } from '../../shared/gql';

const getTransferJobTaskStatus = (state?: UxpTransferState | null) => {
  if (state === 'canceled') return TransferJobTaskStatus.CANCELED;
  if (state === 'completed')
    return TransferJobTaskStatus.TRANSFER_PARTS_COMPLETE;
  if (state === 'failed') return TransferJobTaskStatus.FAILED;
  if (state === 'uploading') return TransferJobTaskStatus.UPLOADING;
  return TransferJobTaskStatus.IDLE;
};

export const useUploadJobItemProgressEvent = (
  onData: (data: UploadJobItemProgressPayload) => void
) => {
  useUploadJobEventsSubscription({
    context: { resolveWithUXP: true },
    onData: (subscriptionData) => {
      const event = subscriptionData.data?.data?.uploadJobEvents;

      if (!event || event.__typename !== 'UploadJobItemProgressPayload') return;

      onData(event);

      createOrUpdateTransferState(event.assetId, {
        status: getTransferJobTaskStatus(event.state),
        assetId: event.assetId,
        progress: {
          bytesSent: event.bytesSent,
          bytesTotal: event.bytesTotal,
          percentage: Math.max(0, Math.min(100, (event.percentage ?? 0) * 100)),
          remainingTime: event.remainingTime,
        },
        filePath: event.filePath,
      });
    },
  });
};
